import React from "react";
import "./BCA_Specializations.css";

import {
  faChartLine,
  faDatabase,
  faLaptopCode,
  faCartShopping,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const specializations = [
  {
    id: 1,
    title: "AI & Business Analytics",
    description:
      "Transform business data into meaningful insights and smarter decisions.",
    icon: faChartLine,
  },
  {
    id: 2,
    title: "Data Science",
    description:
      "Explore data, build intelligent models and solve real-world problems.",
    icon: faDatabase,
  },
  {
    id: 3,
    title: "Web Development & Cloud Computing",
    description:
      "Build scalable web applications and modern cloud-based solutions.",
    icon: faLaptopCode,
  },
  {
    id: 4,
    title: "E-commerce & Digital Marketing",
    description:
      "Master digital commerce, marketing strategies and online growth.",
    icon: faCartShopping,
  },
];

const BCA_Specializations = () => {
  return (
    <section className="bca_specializations" id="programs">
      <div className="bca_specializations_container">
        {/* Section Heading */}
        <div className="bca_section_heading">
          <span className="bca_heading_badge">CAREER-FOCUSED PROGRAMS</span>

          <h2>
            BCA <span>Specializations</span>
          </h2>

          <p>
            Choose your area of expertise and build the skills required for
            tomorrow's technology-driven careers.
          </p>

          <div className="bca_heading_line"></div>
        </div>

        {/* Cards */}
        <div className="bca_specialization_grid">
          {specializations.map((item, index) => (
            <div
              className="bca_specialization_card"
              key={item.id}
              style={{ "--card-index": index }}
            >
              <div className="bca_card_number">0{index + 1}</div>

              <div className="bca_icon_wrapper">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div className="bca_card_content">
                <h3>{item.title}</h3>

                <p>{item.description}</p>
                {/* 
                <div className="bca_card_arrow">
                  <span>Explore Specialization</span>
                  <span className="arrow">→</span>
                </div> */}
              </div>

              <div className="bca_card_shape"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BCA_Specializations;
